/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../../tslib.es6-e01eabb2.js';

function showSharePanel(options, context) {
    var _a;
    var api = 'dd.biz.util.share';
    var formatInput = function (input) {
        var _a = input !== null && input !== void 0 ? input : {}, url = _a.url, title = _a.title, content = _a.content, image = _a.image, _b = _a._ext, _c = _b === void 0 ? {} : _b, _d = _c.dingTalk, dingTalk = _d === void 0 ? {} : _d;
        return __assign({ url: url, title: title, content: content, image: image, type: (dingTalk === null || dingTalk === void 0 ? void 0 : dingTalk.type) || 0 }, dingTalk);
    };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, {
        formatInput: formatInput,
    });
}

export { showSharePanel as default };
